import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { GoalHabitsPeriodType } from './lib/types'
import { useGoalHabits } from './lib/ctx'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

interface TabItem {
  id: GoalHabitsPeriodType
  label: string
}
export const GoalHabitsTabs = () => {
  const theme = useStatsTheme((s) => s.theme)
  const [periodType, setPeriod] = useGoalHabits((s) => [
    s.periodType,
    s.setPeriod,
  ])

  const tabs: TabItem[] = [
    {
      id: 'week',
      label: 'Week',
    },
    {
      id: 'month',
      label: 'Month',
    },
  ]

  const tabIndex = tabs.findIndex((tab) => tab.id === periodType)

  return (
    <FlexBox
      className={css`
        width: 102px;
        height: 32px;
        background-color: ${theme.colors.section.tabBg};
        border-radius: 100px;
        position: relative;
      `}
    >
      <FlexBox
        className={css`
          padding: 2px;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        `}
      >
        <div
          className={css`
            position: relative;
            top: 0;
            width: 50%;
            height: 100%;
            background-color: ${theme.colors.section.tabBtnBg};
            border-radius: 100px;
            transform: translateX(${tabIndex * 100}%);
            transition: transform 0.2s ease-in-out;
            will-change: transform;
          `}
        />
      </FlexBox>
      {tabs.map(({ id, label }) => (
        <FlexBox
          key={id}
          role="button"
          aria-label={`${id} tab`}
          className={css`
            width: 50%;
            height: 100%;
            position: relative;
            z-index: 1;
            cursor: pointer;
            background-color: transparent;
            -webkit-tap-highlight-color: transparent;
            &:active {
              background-color: transparent;
            }
          `}
          centerAll
          onClick={() => setPeriod(id)}
        >
          <Text
            type="body"
            className={css`
              font-size: 10px;
              line-height: 12px;
              transition: color 0.2s ease-in-out;
            `}
            color={
              id === periodType
                ? theme.colors.section.tabBtnText.active
                : theme.colors.section.tabBtnText.idle
            }
            weight="600"
            align="center"
          >
            {label}
          </Text>
        </FlexBox>
      ))}
    </FlexBox>
  )
}
